<div
  class="toolbar-dock"
  [class.is-visible]="toolbarState() === 'visible'"
  [class.is-hidden]="isHidden()">
  <div class="toggle-toolbar-btn-container">
    <kin-icon-btn
      class="toggle-toolbar-btn"
      (onClick)="toggleToolbar()"
      [fill]="false"
      [icon]="toolbarState() === 'visible' ? 'arrow_bottom' : 'arrow_top'"
      [color]="iconColor()"
      size="small" />
  </div>

  <div class="toolbar-content">
    <ng-content></ng-content>
  </div>
</div>
